module.exports = __webpack_public_path__ + "static/media/ic_twitter.3be31a85.svg";